module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M17.214 12.062c2.888 0 5.228-2.34 5.228-5.228s-2.34-5.228-5.228-5.228a5.227 5.227 0 0 0-5.228 5.228c0 .934.312 1.766.742 2.526l-4.344 6.28c-.15-.06-.294-.132-.454-.174a3.966 3.966 0 0 0-4.888 2.828c-.568 2.146.7 4.36 2.828 4.946a3.967 3.967 0 0 0 4.888-2.828 4.04 4.04 0 0 0-.37-2.99l4.772-5.784a5.21 5.21 0 0 0 2.054.424z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/ingredient-secondary.js
// module id = 1193
// module chunks = 14